<script setup>
import { RouterLink, RouterView } from 'vue-router'
</script>

<template>
  <RouterView />
</template>

<style>
/* 确保应用容器透明，不干扰背景图显示 */
:root {
  --background: transparent;
}

body {
  margin: 0;
  padding: 0;
  /* max-width: 400px; */
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
}
</style>
